import { Radio, Input, Button } from "antd";
import styled from "styled-components";
import { getLighterColor } from "../feedback-v2-header/style";
const getPrimary = (props) => { var _a, _b; return ((_b = (_a = props.theme) === null || _a === void 0 ? void 0 : _a.colorPalette) === null || _b === void 0 ? void 0 : _b.primaryColor) || "#5b36f0"; };
export const Wrapper = styled.div `
  padding: 24px 32px 0;
  background: #f4f6fb;
  height: 100%;
  overflow-y: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }

  @media (min-width: 768px) {
    padding: 24px 32px 0;
  }

  @media (max-width: 768px) {
    padding: 16px 12px 0;
  }
`;
export const FeedbackHeaderWrapper = styled.div `
  margin-top: 0;
`;
export const InnerWrapper = styled.div ``;
export const SectionCard = styled.div `
  border-radius: 8px;
  margin-bottom: 32px;
  overflow: hidden;
  border: 1px solid #181d27;
  background: #e6e7ec;
`;
export const SectionHeader = styled.div `
  padding: 18px 32px;
  background: #181d27;
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
`;
export const SectionDivider = styled.div `
  height: 1px;
  background: #eaecf5;
  margin: 0 32px;
`;
export const SectionBody = styled.div `
  padding: 12px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
export const Block = styled.div `
  display: flex;
  flex-direction: column;
  padding: 12px;
  border-radius: 12px;
  border: 1px solid #bbbdd2;
  background: #fff;
`;
export const BlockTitle = styled.div `
  text-transform: capitalize;
  margin-bottom: 4px;
  margin-left: 12px;
  color: #181d27;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.42px;
  margin-bottom: 8px;
`;
export const BlockCard = styled.div `
  background: #ffffff;
  border: 1px solid #dfe3f0;
  border-radius: 16px;
  padding: 16px 12px;
`;
export const BlockCardCommentSection = styled.div `
  background: #ffffff;
`;
export const QuestionList = styled.div `
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
export const QuestionItem = styled.div `
  position: relative;
  padding-left: ${(props) => (props.$number != null ? "32px" : "12px")};
  font-size: 14px;
  color: #181d27;
  line-height: 20px;
  font-weight: 500;

  &::before {
    content: ${(props) => props.$number != null ? `"${props.$number}."` : "none"};
    position: absolute;
    left: 12px;
    top: 0;
    color: #3d4059;
    font-weight: 600;
  }
`;
export const SubQuestionItem = styled.div `
  padding-left: 38px;
  font-size: 13px;
  color: #252733;
  line-height: 18px;
  counter-increment: none;
  position: relative;

  &::before {
    content: "•";
    position: absolute;
    left: 24px;
    color: #3d4059;
  }
`;
export const OrSeparator = styled.div `
  padding-left: 32px;
  font-size: 14px;
  font-weight: 500;
  color: #181d27;
  line-height: 20px;
`;
export const FeedbackOptions = styled(Radio.Group) `
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
export const FeedbackOption = styled(Radio) `
  padding: 14px 18px;
  border: 1px solid #dfe3f0;
  border-radius: 14px;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  background: #fff;

  .ant-radio-inner {
    border-color: ${getPrimary};
  }

  &.ant-radio-wrapper-checked {
    border-color: ${getPrimary};
    background: #ffffff;
    box-shadow: none;
    background: ${(props) => getLighterColor(props.theme.colorPalette.primaryColor, 0.05)};
  }
`;
export const OptionContent = styled.div `
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
export const OptionLabel = styled.div `
  color: #181d27;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.42px;
`;
export const OptionDescription = styled.div `
  color: #2d2f45;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.42px;
`;
export const CommentsTextArea = styled(Input.TextArea) `
  border-radius: 12px;
  border: 1px solid #dadde7;
  padding: 10px 12px;
  font-size: 14px;
  color: #181d27;
  background: #fff;
  resize: none;

  textarea {
    overflow-y: hidden !important;
    line-height: 20px;
  }

  &::placeholder {
    color: #454760;
  }

  &:focus,
  &:hover {
    border-color: ${getPrimary};
    box-shadow: 0 0 0 2px rgba(91, 54, 240, 0.1);
  }

  &[readonly] {
    cursor: default;
    background: #fff;
    color: #181d27;
  }
`;
export const FinalDecisionCard = styled(SectionCard) `
  margin-top: 16px;
  flex: 1;
  background: white;
`;
export const FinalDecisionRow = styled.div `
  display: flex;
  flex-direction: column;
  gap: 0;
  margin-top: 0;
`;
export const FinalDecisionBody = styled.div `
  padding: 16px 24px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
export const FinalDecisionColumn = styled.div `
  flex: 1;
  width: 100%;
  display: flex;
  flex-direction: column;
`;
export const FinalDecisionOptions = styled(Radio.Group) `
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
  margin-top: 0;
`;
export const FinalDecisionOption = styled(Radio) `
  padding: 14px 18px;
  border: 1px solid #dfe3f0;
  border-radius: 14px;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  width: 100%;
  margin-inline-end: 0 !important;

  .ant-radio-inner {
    border-color: ${getPrimary};
  }

  .ant-radio + span {
    margin-left: 10px;
    display: inline-flex;
    align-items: center;
    line-height: 20px;
    color: #181d27;
    font-weight: 500;
    font-size: 14px;
  }

  &.ant-radio-wrapper-checked {
    border-color: ${getPrimary};
    background: ${(props) => getLighterColor(props.theme.colorPalette.primaryColor, 0.05)};

    .ant-radio-inner {
      border-color: ${getPrimary};
    }
  }
`;
export const SubmitButtonWrapper = styled.div `
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  padding-bottom: 24px;
  @media (max-width: 768px) {
    padding-right: 12px;
    margin-top: 12px;
  }
`;
export const SubmitButton = styled(Button) `
  border-radius: 12px;
  padding: 0 32px;
  height: 48px;
  font-weight: 600;
  color: #fff !important;
  border: none;
  background: linear-gradient(135deg, #ff5b37 0%, #ff2e63 100%);
  box-shadow: 0px 12px 24px rgba(255, 46, 99, 0.25);

  &:hover,
  &:focus {
    color: #fff !important;
    opacity: 0.92;
  }
`;
export const FeedbackInfoBar = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #2c3e50;
  border-radius: 8px;
  padding: 16px 24px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
    padding: 12px 16px;
  }
`;
export const FeedbackInfoText = styled.div `
  color: #d1d5db;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const FeedbackInfoName = styled.span `
  color: #f3f4f6;
  font-weight: 500;
`;
